import tt from "@tomtom-international/web-sdk-maps";
import "@tomtom-international/web-sdk-maps/dist/maps.css";
import { Form } from "antd";
import { useEffect, useState } from "react";
import { roles, tomtomApiKey } from "../../../../utils/constants";
import { onlyRoleMapping } from "../../../../engine/AuthRoute";

export const TomTomMaps = ({ keys, refForm }) => {
  let r = onlyRoleMapping([roles.admin, roles.permanance]);
  const [visible, setVisible] = useState(false);
  const address = Form.useWatch(keys);

  useEffect(() => {
    let map = null;
    let marker = null;

    if (
      refForm !== undefined &&
      refForm.current !== null &&
      address !== undefined
    ) {
      let values = refForm?.current[`_${keys}`]?.find(e => e._id === address);
      let fromApICalllng_ = refForm.current.getFieldValue("lng_" + keys);
      let fromApICalllat_ = refForm.current.getFieldValue("lat_" + keys);

      let longitude;
      let latitude;

      // from values from dynamic select DB
      if (values && values.longitude && values.latitude) {
        longitude = values.longitude;
        latitude = values.latitude;
      }

      // FROM new api Call
      if (fromApICalllng_ && fromApICalllat_) {
        longitude = fromApICalllng_;
        latitude = fromApICalllat_;
      }

      if (longitude && latitude) {
        map = tt.map({
          key: tomtomApiKey, // Remplacez par votre clé API TomTom
          container: "map", // ID de l'élément HTML où la carte sera affichée
          center: [longitude, latitude], // Coordonnées récupérées
          zoom: 16,
          interactive: r,
          styleMode: "dark",
          style: {
            map: "2/basic_street-satellite", // Satellite avec routes superposées
            poi: "", // Style pour les POI (points d'intérêt)
            trafficIncidents: "", // Style pour les incidents de trafic
            trafficFlow: "", // Style pour le flux de trafic
          },
          stylesVisibility: {
            map: true, // Affiche la couche de base
            poi: false, // Affiche les points d'intérêt (POI)
            trafficFlow: false, // Cache le flux de trafic
            trafficIncidents: false, // Cache les incidents de trafic
          },
          // style: "basic_main-lite",
          // style: "tomtom://vector/1/basic-main",
          // style: "tomtom://vector/1/basic_street-light",
        });

        // Créer et ajouter un marqueur à la carte
        marker = new tt.Marker().setLngLat([longitude, latitude]).addTo(map);

        setVisible(true);
      } else {
        setVisible(false);
      }
    }

    // Nettoyer la carte et le marqueur lorsqu'ils ne sont plus utilisés
    return () => {
      if (map) map?.remove();
      if (marker) marker?.remove();
    };
  }, [address, refForm, keys]);

  return (
    <div
      id="map"
      style={{
        width: "100%",
        height: visible ? "400px" : "0",
        maxHeight: "500px",
      }}
    />
  );
};
